module.exports = __webpack_public_path__ + "img/sj.1f960197.svg";